// TechnicianReportPDF.js
import {
  Document,
  Font,
  Image,
  Page,
  StyleSheet,
  Text,
  View
} from "@react-pdf/renderer";
import React from "react";
import facebook from '../../../src/images/homepage/footer/facebook.png';
import instagram from '../../../src/images/homepage/footer/instagram.png';
import linkedin from '../../../src/images/homepage/footer/linkedin.png';
import twitter from '../../../src/images/homepage/footer/twitter.png';
import profile from '../../../src/images/pdf/login.png';
import { default as footerLogo, default as logo } from '../../../src/images/pdf/nav.png';
import tyre from "../../../src/images/pdf/tyre.png";
import car from "../../../src/images/progress/car.png";
// Styles for PDF layout

Font.register({
  family: 'Poppins',
  src: require('../../../src/font/Poppins-Regular.ttf'),
});

Font.register({
  family: 'PoppinsS',
  src: require('../../../src/font/Poppins-SemiBold.ttf'),
});

const styles = StyleSheet.create({
  page: {
    fontSize: 14,
    backgroundColor: "#ffff",
    fontFamily: 'Poppins', // Use the registered font family here
    

  },

  main: {
    width: "100%",
    height: 70,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 60,
    backgroundColor: "#0F1205",
    paddingLeft: 30,
  },
  logo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 140,
    height: 40,
  },

  header: {
    fontSize: 14,
    textAlign: "center",
    color: "#F0FFC5",
    fontWeight: "extrabold",
  },

  container: {
    marginVertical: 10,
    paddingHorizontal: 10,
    paddingVertical: 12,
    backgroundColor: "#ffffff",
    borderRadius: 6,
  },


  loginContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingLeft: 28,
    gap: 20,
    marginBottom: 20,
  },

  login: {
    width: 20,
    height: 20,
  },

  loginName:{
    fontWeight:"extrabold",

  },

  headerLeft: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  section: {
    marginTop: 30,
    marginVertical: 10,
    paddingHorizontal: 10,
    paddingVertical: 12,
    backgroundColor: "#ffffff",
    borderRadius: 6,
  },
  label: {
    fontWeight: "bold",
    color: "#000",
  },
  content: {
    color: "#333",
    fontSize: 12,
    marginTop: 3,
  },
  row: {
    flexDirection: "row",
    justifyContent: "center",
    marginVertical: 6,
  },
  imageRow: {
    flexDirection: "row",
    justifyContent: "space-around",
    marginTop: 15,
  },
  imageRows: {
    flexDirection: "row",
    justifyContent: "space-around",
    marginTop: 15,
  },

  

  imageFirst:{
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    backgroundColor: "#f4f4f4",
    width: "100%",
    height: "100%",
  },
  image: {
    width: 80,
    height: 80,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: "#ddd",
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: "#e4e4e8",
    marginVertical: 15,
  },

  // new code

  sectionmain: {
    display: "flex",
    flexDirection: "row",
    marginTop: 10,
    gap: 20,
  },
  leftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    gap: 10,
  },
  // rightContainer: {
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "center",
  //   backgroundColor: "#E9E8E8",
  //   padding: 10,
  // },
  labelHeader: {
    fontWeight: "extrabold",
    color: "#1F1F1F",
    fontSize: "18px",
  },
  donutChart: {
    width: 120,
    height: 120,
    borderRadius: 60, // To mimic a circular chart
  },

  carDetialsText: {
    flex: 1,
    alignItems: "center", // Center text horizontally
    justifyContent: "center", // Center text vertically
    paddingHorizontal: 10,
    borderRightWidth: 1, // Right border width
    borderRightColor: "#0F1205", // Light gray border color
  },
  carDetailsTextDetails: {
    fontSize: 10,
    color: "#333", // Dark text color
  },

  carDetailsTextDetailsNum: {
    fontSize: "12px",
    color: "#1F1F1F", // Dark text color
    fontWeight:800,
    marginBottom:2,
  },

  imageCar: {
    width: 120,
    height: 70,
  },
  containerGray: {
    backgroundColor: "#E9E8E8",
    padding: 10,
    borderRadius:5,
  },

  containerGrays: {
    backgroundColor: "#E9E8E8",
    padding: 10,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  containerGray2: {
    backgroundColor: "#E9E8E8",
    padding: 20,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 10,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
  },

  rightContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingTop:50,
  },
  GrayContainerRight: {
    width: "90%", // Adjust width as needed
    backgroundColor: "#E9E8E8", // Gray background color
    padding: 20,
    alignItems: "center", // Center text horizontally
    justifyContent: "start", // Center text vertically
    borderRadius: 5, // Optional for rounded corners
    marginVertical: 5, // Add spacing between containers
    
    marginHorizontal: 30,
    gap: 10,
  },

  textHeading: {
    textAlign: "center",
    fontWeight: "extrabold",
    fontSize: "12px",
  },
  textHeadingbtm: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "11px",
  },

  progressBarContainer: {
    width: "100%",
    height: 20,
    backgroundColor: "#e0e0e0",
    borderRadius: 10,
    
  },
  progressBar: (percentage) => ({
    height: "100%",
    width: `${percentage}%`,
    backgroundColor:
      percentage >= 75 ? "#4caf50" : percentage >= 50 ? "#ffeb3b" : "#f44336",
    borderRadius: 10,
  }),

  imageGridContainer: {
   
    backgroundColor: "#E9E8E8", // Gray background
    padding: 10, // Padding around the grid
    borderRadius: 10, // Optional for rounded corners
    marginVertical: 10, // Space between this grid and other components
  },

  // Row container for the placeholders
  imageRows: {
    flexDirection: "row", // Arrange placeholders in a row
    justifyContent: "center", // Space evenly between items
    marginBottom: 10,
    gap: 2, // Space between rows
  },

  // Placeholder for individual image boxes
  imagePlaceholder: {
    backgroundColor: "#d3d3d3",
    width: "30%", // Each placeholder takes half the row width with spacing
    aspectRatio: 1, // Maintain a square shape
    borderRadius: 8, // Optional for rounded corners
  },

  // Engine Performance
  EnginePerformanceHeading: {
    
    marginVertical: 10, // Add spacing above and below
    padding: 10, // Add padding inside
    textAlign: "center", // Center the text horizontally
  },
  EnginePerformanceHeadingText: {
    fontSize: 14, // Font size for readability
    color: "#000", // Ensure contrasting text color
    fontWeight: "bold", // Optional for emphasis
    textAlign: "center",
    marginBottom:20,
    fontFamily:'PoppinsS',
    
  },

  evaluationContainer: {
    margin: 10,
    padding: 30,
    backgroundColor: "#E9E8E8",
    borderRadius: 10,
    borderColor: "#E9E8E8",
    borderWidth: 1,
    height: "26%",
    position: "relative",
    minHeight:'250px',
    
  },

  statusBadge: {
    position: "absolute",
    top: -28,
    right: -1,
    backgroundColor: "#E9E8E8",
    borderRadius: 5,
    paddingHorizontal: 15,
    paddingVertical: 10,
   
  },
  statusBadgeText: {
    fontSize: 12,
    color: "#000",
    fontWeight: "bold",
  },
  heading: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 20,
  },

  tableHeader: {
    fontWeight: "bold",
    fontSize: 12,
  },
  evaluationLabel: {
    fontSize: 12,
  },
  col1: {
    flex: 2,
  },
  col2: {
    flex: 2,
    textAlign: "center",
  },
  col3: {
    flex: 3,
    textAlign: "right",
  },
  issueText: {
    color: "#e60000",
    
    fontWeight: "bold",
  },
  recommendationText: {
    color: "#e60000",
    fontWeight: "bold",
  },


  //


  cardContainer: {
    borderWidth: 1,
    borderColor: "#E0E0E0",
    borderRadius: 10,
    padding: 15,
    backgroundColor: "#E9E8E8",
    width: "90%",
    alignSelf: "center",
    marginVertical: 10,
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    position:'relative',
    borderTopRightRadius:'0',
  },
  statusContainer: {
    position:'absolute',
    top:'-17',
    right:'-1',
    borderBottom:'0',
    backgroundColor: "#E9E8E8",
    borderRadius: 5,
    paddingHorizontal: 10,
    alignSelf: "flex-end",
    marginBottom: 10,
  },
  statusText: {
    fontSize: 12,
    color: "#000",
    fontWeight: "500",
  },
  statusOkText: {
    color: "#28A745",
    fontWeight: "700",
  },
  cardHeading: {
    fontSize: 14,
    fontWeight: "800",
    color: "#000",
    textAlign: "center",
    marginBottom: 10,
  },
  cardSubText: {
    fontSize: 13,
    color: "#000",
    fontWeight: "600",
    marginBottom: 5,
  },
  cardDescription: {
    fontSize: 12,
    color: "#555",
    textAlign: "center",
    marginTop: 10,
    
  },

  // System Observations

  vehicleObservationsContainer: {
    
    
    padding: 10,
   
    borderRadius: 6,
    marginTop:'80px'
  },
  vehicleObservationsContainers: {
   
    
    padding: 10,
    
    borderRadius: 8,
  },
  observationsDetailsContainer: {
    padding: 10,
    backgroundColor: "#E9E8E8",
    borderRadius: 8,
    elevation: 2,
    position:'relative',
  },
  observationsHeading: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 10,
  },
  observationsStatusBadge: {
    alignSelf: "flex-end",
    paddingVertical: 5,
    paddingHorizontal: 15,
    backgroundColor: "#E9E8E8",
    borderRadius:5,
    
    marginBottom: 15,

       
    position: "absolute",
    top: -21,
    right: 0,
   
   
  },
  statusBadgeTexts: {
    color: "#000",
    fontSize: 12,
    fontWeight: "600",
  },
  tableHeaderRow: {
    flexDirection: "row",
    alignItems:'center',
    justifyContent:'center',
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    paddingBottom: 5,
    marginBottom: 5,
    textAlign:'center',
  },
  tableHeaderCell: {
    fontWeight: "600",
    fontSize: 12,

  },
  column1: {
    flex: 3,
    textAlign:'center',
  },
  column2: {
    flex: 2,
    textAlign:'center',
  },
  column3: {
    flex: 3,
    textAlign:'center',
  },
  tableRows: {
    paddingTop:5,
    display:'flex',
    flexDirection: "row",
    alignItems:'center',
    justifyContent:'center',
    marginBottom: 8,
    paddingHorizontal:50,
    textAlign:'center',
    
  },

  tableRow: {
    paddingTop:5,
    flexDirection: "row",
    alignItems:'center',
    justifyContent:'center',
    marginBottom: 8,
    paddingHorizontal:50,
    textAlign:'center',
    
  },
  tableCell: {
    fontSize: 12,
   
  },
  
  new:{

    flexDirection:'column',
    alignItems:'flex-end',
    justifyContent:'center',
    fontSize:12,

  },

  // Image Three Flex

  imageThreeContaier: {
    marginTop: 80,
    flexDirection: "row", // Arranges children in a row
    justifyContent: "center", // Equal space between boxes
    alignItems: "center", // Align boxes vertically
    padding: 16, // Padding around the container
    backgroundColor: "#f4f4f4", // Optional container background color
    gap: 10,
  },
  boximage: {
    width: 100, // Width of each box
    height: 100, // Height of each box
    backgroundColor: "#d3d3d3", // Gray box color
    borderRadius: 8, // Rounded corners for a smoother look
    elevation: 2, // Adds shadow for Android
    shadowColor: "#000", // Adds shadow for iOS
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },



  // vehicleObservationsContainer: {
  //   padding: 20,
  //   backgroundColor: '#f9f9f9', // Neutral background
  //   borderRadius: 10,
  // },
  // EnginePerformanceHeadingText: {
  //   fontSize: 20,
  //   fontWeight: 'bold',
  //   textAlign: 'center',
  //   marginBottom: 15,
  // },
  containerimage: {
    position: 'relative',
    width: '100%',
    alignItems: 'center',
  },
  rowimage: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 5,
  },
  percentageBoximage: {
    width: 50,
    height: 50,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    backgroundColor: "#d3d3d3",
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 5,
  },
  percentageTextimage: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#333',
  
  },
  imageContainerimage: {
    width: '100%',
    alignItems: 'center',
    marginVertical: 15,
  },
  tyreImage: {
    width: '90%',
    height: 200,
  },
  topLeft: {
    position: 'absolute',
    left: '25%',
    top: -30,
  },
  topRight: {
    position: 'absolute',
    right: '20%',
    top: -30,
  },
  bottomLeft: {
    position: 'absolute',
    left: '25%',
    bottom: -30,
  },
  bottomRight: {
    position: 'absolute',
    right: '20%',
    bottom: -30,
  },

  spareTire: {
    position: 'absolute',
    top: '30%', // Center vertically
    right:0, // Center horizontally
    transform: [{ translateX: -25 }, { translateY: -25 }], // Adjust for proper alignment
    width: 50,
    height: 50,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    backgroundColor: "#d3d3d3",
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 5,
  },

  // Tyre image inspection

  // containerimage: {
  //   justifyContent: "center",
  //   alignItems: "center",
  //   position: "relative", // Allows absolute positioning within this container
  // },
  // rowimage: {
  //   position: "absolute",
  //   width: "100%",
  // },
  // percentageBoximage: {
  //   width: 60,
  //   height: 60,
  //   borderRadius: 8,
  //   borderWidth: 1,
  //   borderColor: "#ccc",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   backgroundColor: "#fff",
  //   position: "absolute", // Enables precise placement
  // },
  // percentageTextimage: {
  //   fontSize: 16,
  //   fontWeight: "bold",
  // },
  // imageContainerimage: {
  //   marginVertical: 20,
  //   minHeight:40,
  // },
  // tyreImage: {
  //   width: 300,
  //   height: 150,
  //   resizeMode: "contain", // Maintains the aspect ratio of the image
  // },
  // topLeft: {
  //   top: 0,
  //   left: 40,
  // },
  // topRight: {
  //   top: 0,
  //   right: 40,
  // },
  // bottomLeft: {
  //   bottom: 0,
  //   left: 40,
  // },
  bottomRights: {
    bottom: 0,
    right: 40,
  },

  // Remarks

  remarksList: {
    marginTop: 10,
  },
  remarkItem: {
    fontSize: 16,
    color: "#333",
    marginVertical: 5,
    lineHeight: 5,
  },

  // Footer
  footerContainer: {
    backgroundColor: '#1F1F1F',
    color: '#FFFFFF',
    padding: 20,
    marginTop: 100
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  sectionss: {
    width: '23%', // Adjust width for layout
    marginBottom: 20,
  },
  footerLogo: {
    width: 100,
    height: 50,
    marginBottom: 10,
  },
  description: {
    fontSize: 10,
    color: '#D1D1D1',
    marginBottom: 15,
  },
  socialIcons: {
    display: 'flex',
    flexDirection: 'row',
    gap: 5,
  },
  iconWrapper: {
    padding: 5,
  },
  socialIcon: {
    width: 15,
    height: 15,
  },
  sectionHeading: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  listItem: {
    fontSize: 10,
    marginBottom: 5,
  },
  dividers: {
    borderTop: '1px solid #D1D1D1',
    marginVertical: 10,
  },
  copyright: {
    fontSize: 8,
    textAlign: 'center',
    color: '#FFFFFF',
  },
});

const PreTripPDF = ({ reportData, serviceData, carImageUrl }) => {

// Accessing values in reportData (example: reportData.issueB)

// Defining all states that belong to different sections

function calculateTotalDeduction(states, deductionPerState) {
  // Filter out invalid states
  const validStates = states.filter(
    (state) => state !== null && state !== undefined && state !== "" && Boolean(state)
  );

  // Calculate the total deduction
  return validStates.length * deductionPerState;
}

// Body and Paint Section Data
const bodyAndPaint = [
  reportData?.issueB,
  reportData?.issueFB,
  reportData?.issueFRQP,
  reportData?.issueFD,
  reportData?.issueRRD,
  reportData?.issueRRQP,
  reportData?.issueBT,
  reportData?.issueFLF,
  reportData?.issueFLDS,
  reportData?.issueRLDS,
  reportData?.selectedConditionSensor1,
  reportData?.selectedConditionSensor2,
];

// Deduction per valid state
const deductionPerState = 0.82;

// Calculate total deduction for Body and Paint section
const totalDeduction = calculateTotalDeduction(bodyAndPaint, deductionPerState);

// console.log(`Total Deduction for Body and Paint: ${totalDeduction.toFixed(2)}%`);

function calculateTotalDeductionFromConditions(conditions, deductionPerCondition) {
  // Filter out only truthy conditions
  const validConditions = conditions.filter((condition) => Boolean(condition));

  // Calculate the total deduction
  return validConditions.length * deductionPerCondition;
}

// Engine Performance Section Data with Conditions
const enginePerformance = [
  reportData?.BatteryEnergy < 11.5,
  reportData?.LoadEngine > 35,
  reportData?.idleRPM > 1400,
];

// Deduction per valid condition
const deductionPerCondition = 2.5;

// Calculate total deduction for Engine Performance section
const totalDeductionEngine = calculateTotalDeductionFromConditions(
  enginePerformance,
  deductionPerCondition
);

// console.log(`Total Deduction for Engine Performance: ${totalDeductionEngine.toFixed(2)}%`);

function calculateTotalDeductionForTrueStates(states, deductionPerTrueState) {
  // Log each state to see its value
  // console.log("State values for System Observations:");
  states.forEach((state, index) => {
    // console.log(`State ${index + 1}: ${state}`);
  });

  // Count how many true states exist (because only true states should reduce the percentage)
  const trueStates = states.filter(state => state === true); // Only count truthy (true) values
  // console.log(`Number of true states: ${trueStates.length}`);

  // Calculate total deduction for all true states
  return trueStates.length * deductionPerTrueState;
}

// System Observations Section Data
const systemObservations = [
  !reportData?.isToggledEngineCrack, // Example: No issue (value should be true, so no deduction)
  !reportData?.isToggledWarning,
  !reportData?.isToggledSuspicious,
  !reportData?.isToggledSmoke,
  !reportData?.isToggledGearshift,
  !reportData?.isToggledBreak,
  !reportData?.isToggledSteering,
  !reportData?.isToggledHandbreak,
  !reportData?.isToggledReverse,
  !reportData?.isToggledSmooth,
];

// Deduction per true value
const deductionPerTrueState = 2.8409;

// Calculate total deduction for System Observations section
const totalDeductionSystemObservations = calculateTotalDeductionForTrueStates(
  systemObservations,
  deductionPerTrueState
);

// console.log(`Total Deduction for System Observations: ${totalDeductionSystemObservations.toFixed(2)}%`);

function calculateTotalCarprtDeductionForTrueStates(states, deductionPerTrueState) {
  // Log each state to see its value
  // console.log("State values for Carpet section:");
  states.forEach((state, index) => {
    // console.log(`State ${index + 1}: ${state}`);
  });

  // Count how many true or non-falsy states exist (because only true or valid values should reduce the percentage)
  const validStates = states.filter(state => state); // Filter out falsy values (null, undefined, false, etc.)
  // console.log(`Number of valid states (truthy): ${validStates.length}`);

  // Calculate total deduction for all valid states
  return validStates.length * deductionPerTrueState;
}

// Carpet Section Data
const carpetStates = [
  reportData.selectedConditionDS,
  reportData.selectedConditionCDS,
  reportData.selectedConditionDRS,
  reportData.selectedConditionCDRS,
  reportData.selectedConditionBI
];

// Deduction per valid value
const deductionPerCarpetValidState = 0.82;

// Calculate total deduction for Carpet section
const totalDeductionCarpet = calculateTotalCarprtDeductionForTrueStates(
  carpetStates,
  deductionPerCarpetValidState
);

// console.log(`Total Deduction for Carpet section: ${totalDeductionCarpet.toFixed(2)}%`);

function calculateTotalPanelDeductionForTrueStates(states, deductionPerTrueState) {
  // Log each state to see its value
  // console.log("State values for Plastic Panel section:");
  states.forEach((state, index) => {
    // console.log(`State ${index + 1}: ${state}`);
  });

  // Count how many true or non-falsy states exist (because only true or valid values should reduce the percentage)
  const validStates = states.filter(state => state); // Filter out falsy values (null, undefined, false, etc.)
  // console.log(`Number of valid states (truthy): ${validStates.length}`);

  // Calculate total deduction for all valid states
  return validStates.length * deductionPerTrueState;
}

// Plastic Panel Section Data
const plasticPanelStates = [
  reportData?.selectedConditionPDS,
  reportData?.selectedConditionPCDS,
  reportData?.selectedConditionPDRS,
  reportData?.selectedConditionPCDRS,
  reportData?.selectedConditionBIS,
  reportData?.selectedConditionD,
  reportData?.selectedConditionGC
];

// Deduction per valid value
const deductionPerValidState = 0.82;

// Calculate total deduction for Plastic Panel section
const totalDeductionPlasticPanel = calculateTotalPanelDeductionForTrueStates(
  plasticPanelStates,
  deductionPerValidState
);

// console.log(`Total Deduction for Plastic Panel section: ${totalDeductionPlasticPanel.toFixed(2)}%`);

function calculateTotalSeatDeductionForTrueStates(states, deductionPerTrueState) {
  // Log each state to see its value
  // console.log("State values:");
  states.forEach((state, index) => {
    // console.log(`State ${index + 1}: ${state}`);
  });

  // Count how many true or non-falsy states exist (because only true or valid values should reduce the percentage)
  const validStates = states.filter(state => state); // Filter out falsy values (null, undefined, false, etc.)
  // console.log(`Number of valid states (truthy): ${validStates.length}`);

  // Calculate total deduction for all valid states
  return validStates.length * deductionPerTrueState;
}

// Seat Section Data
const seatStates = [
  reportData.selectedConditionSDS,
  reportData?.selectedConditionSCDS,
  reportData?.selectedConditionSDRS,
  reportData?.selectedConditionSCDRS,
  reportData?.selectedConditionHR,
  reportData?.selectedConditionCHR,
  reportData?.selectedConditionRHR,
  reportData?.selectedConditionHCDR
];

// Rubber Components Section Data
const rubberComponentsStates = [
  reportData?.selectedConditionRC1,
  reportData?.selectedConditionRC2,
  reportData?.selectedConditionRC3,
  reportData?.selectedConditionRC4,
  reportData?.selectedConditionRC5,
  reportData?.selectedConditionRC6
];

// Glass & Mirrors Section Data
const glassAndMirrorsStates = [
  reportData?.selectedConditionGM2,
  reportData?.selectedConditionGM3,
  reportData?.selectedConditionGM4,
  reportData?.selectedConditionGM6,
  reportData?.selectedConditionGM8,
  reportData?.selectedConditionGM10,
  reportData?.selectedConditionGM12,
  reportData?.selectedConditionGM14,
  reportData?.selectedConditionGM15,
  reportData?.selectedConditionGM17,
  reportData?.selectedConditionGM19,
  reportData?.selectedConditionGM21
];

// Tyres Section Data
const tyresStates = [
  reportData?.selectedConditionFT,
  reportData?.selectedConditionRTN,
  reportData?.selectedConditionRLN,
  reportData?.selectedConditionFLNT,
  reportData?.selectedConditionSparen
];

// Deduction per valid value
const deductionPerSeatValidState = 2.5;

// Calculate total deduction for Seat section
const totalDeductionSeat = calculateTotalSeatDeductionForTrueStates(
  seatStates,
  deductionPerSeatValidState
);

// Calculate total deduction for Rubber Components section
const totalDeductionRubberComponents = calculateTotalSeatDeductionForTrueStates(
  rubberComponentsStates,
  deductionPerSeatValidState
);

// Calculate total deduction for Glass & Mirrors section
const totalDeductionGlassAndMirrors = calculateTotalSeatDeductionForTrueStates(
  glassAndMirrorsStates,
  deductionPerSeatValidState
);

// Calculate total deduction for Tyres section
const totalDeductionTyres = calculateTotalSeatDeductionForTrueStates(
  tyresStates,
  deductionPerSeatValidState
);

// Output total deductions for each section
// console.log(`Total Deduction for Seat section: ${totalDeductionSeat.toFixed(2)}%`);
// console.log(`Total Deduction for Rubber Components section: ${totalDeductionRubberComponents.toFixed(2)}%`);
// console.log(`Total Deduction for Glass & Mirrors section: ${totalDeductionGlassAndMirrors.toFixed(2)}%`);
// console.log(`Total Deduction for Tyres section: ${totalDeductionTyres.toFixed(2)}%`);

// Function to calculate deduction based on valid (truthy) states
function calculateTotalCoreDeductionForTrueStates(states, deductionPerTrueState) {
  // Log each state to see its value
  // console.log("State values:");
  states.forEach((state, index) => {
    // console.log(`State ${index + 1}: ${state}`);
  });

  // Count how many true or non-falsy states exist (excluding "Others")
  const validStates = states.filter(state => state && state !== "Others"); // Exclude "Others" as empty
  // console.log(`Number of valid states (truthy, excluding "Others"): ${validStates.length}`);

  // Calculate total deduction for all valid states
  return validStates.length * deductionPerTrueState;
}

// Car's Core Mechanical Area Conditions Data
const carsCoreMechanicalStates = [
  reportData?.selectedConditionCarsCore2,
  reportData?.selectedConditionCarsCore3,
  reportData?.selectedConditionCarsCore1,
  reportData?.selectedConditionCarsCore11,
  reportData?.selectedConditionCarsCore4,
  reportData?.selectedConditionCarsCore5,
  reportData?.selectedConditionCarsCore6,
  reportData?.selectedConditionCarsCore7,
  reportData?.selectedConditionCarsCore8,
  reportData?.selectedConditionCarsCore9,
  reportData?.selectedConditionCarsCore10,
  reportData?.selectedConditionCarsCore12
];

// Deduction per valid value
const deductionPerCoreValidState = 2.8409;

// Calculate total deduction for Car's Core Mechanical Area Conditions section
const totalDeductionCarsCoreMechanical = calculateTotalCoreDeductionForTrueStates(
  carsCoreMechanicalStates,
  deductionPerCoreValidState
);

// Output total deduction for this section
// console.log(`Total Deduction for Car's Core Mechanical Area Conditions: ${totalDeductionCarsCoreMechanical.toFixed(2)}%`);

// Function to calculate total deduction for valid states, excluding exempt states
function calculateTotalFluidDeductionForValidStates(states, exemptionStates, deductionPerTrueState) {
  // Log each state to see its value
  // console.log("State values:");
  states.forEach((state, index) => {
    // console.log(`State ${index + 1}: ${state}`);
  });

  // Filter out falsy values and exempt states
  const validStates = states.filter((state, index) => state && !exemptionStates.includes(state));
  // console.log(`Number of valid states (truthy, excluding exemptions): ${validStates.length}`);

  // Calculate total deduction for all valid states
  return validStates.length * deductionPerTrueState;
}

// Fluid Level section (minus 0.82% for each state with a value except specific states)
const fluidLevelStates = [
  reportData.isToggledFluidLevel1,
  reportData.isToggledFluidLevel2,
  reportData.isToggledFluidLevel3,
  reportData.isToggledFluidLevel4,
  reportData.isToggledFluidLevel5,
  reportData.isToggledFluidLevel6,
  reportData.isToggledFluidLevel7,
  reportData.isToggledFluidLevel8,
  reportData.isToggledFluidLevel9,
  reportData.isToggledFluidLevel10,
  reportData.isToggledFluidLevel11
];

// Specific states that should not cause a deduction in the Fluid Level section
const exemptFluidLevelStates = [
  reportData.isToggledFluidLevel1,
  reportData.isToggledFluidLevel3,
  reportData.isToggledFluidLevel5,
  reportData.isToggledFluidLevel7
];

// Panel Gap section (minus 0.82% for each state with a value)
const panelGapStates = [
  reportData.selectedButtonGO,
  reportData.selectedButtonGOBL,
  reportData.selectedButtonGOFRD,
  reportData.selectedButtonGOFLD,
  reportData.selectedButtonGORRDR,
  reportData.selectedButtonGORRLD,
  reportData.selectedButtonGOBR,
  reportData.selectedButtonGOBT,
];

// Infotainment And Electronic Features section (minus 0.82% for each state with a value)
const infotainmentAndEletronicFeaturesStates = [
  reportData?.selectedConditionIS,
  reportData?.selectedConditionSASQ,
  reportData?.selectedConditionPW,
  reportData?.selectedConditionGCO,
  reportData?.selectedConditionCQ
];

// Deduction per valid value
const deductionPerFluidValidState = 2.5;

// Calculate total deduction for Fluid Level section
const totalDeductionFluidLevel = calculateTotalFluidDeductionForValidStates(
  fluidLevelStates,
  exemptFluidLevelStates,
  deductionPerFluidValidState
);
// console.log(`Total Deduction for Fluid Level: ${totalDeductionFluidLevel.toFixed(2)}%`);

// Calculate total deduction for Panel Gap section
const totalDeductionPanelGap = calculateTotalFluidDeductionForValidStates(
  panelGapStates,
  [], // No exemptions for Panel Gap section
  deductionPerFluidValidState
);
// console.log(`Total Deduction for Panel Gap: ${totalDeductionPanelGap.toFixed(2)}%`);

// Calculate total deduction for Infotainment and Electronic Features section
const totalDeductionInfotainmentAndEletronicFeatures = calculateTotalFluidDeductionForValidStates(
  infotainmentAndEletronicFeaturesStates,
  [], // No exemptions for Infotainment section
  deductionPerFluidValidState
);
// console.log(`Total Deduction for Infotainment and Electronic Features: ${totalDeductionInfotainmentAndEletronicFeatures.toFixed(2)}%`);

// Function to update score based on states with values
// function updateScore() {
//   // Check each section and decrease score accordingly
//   const allSections = [
//     { states: paintAndBodyStates, decrease: 2 },
//     { states: carpetStates, decrease: 5 },
//     { states: plasticPanelStates, decrease: 5 },
//     { states: seatStates, decrease: 5 },
//     { states: rubberComponentsStates, decrease: 5 },
//     { states: glassAndMirrorsStates, decrease: 5 },
//     { states: tyresStates, decrease: 5 },
//     { states: carsCoreMechanicalStates, decrease: 5 },
//     { states: fluidLevelStates, decrease: 5 }
//   ];

//   // Loop through each section and reduce the score
//   allSections.forEach(section => {
//     section.states.forEach((state, index) => {
//       console.log(`State ${index + 1}:`, state); // Log the value of each state

//       // Skip deduction for exempt fluid level states
//       if (
//         section === fluidLevelStates &&
//         exemptFluidLevelStates.includes(state)
//       ) {
//         console.log(`State ${index + 1} is exempt, no deduction.`);
//         return;
//       }

//       if (state) {
//         console.log(`State ${index + 1} has a value, deducting ${section.decrease}%`);
//         scorePercentage -= section.decrease;
//       }
//     });
//   });
// }

// // Call the function to update the score based on reportData
// updateScore();

// // Final score percentage after deductions
// console.log("Final score percentage:", scorePercentage);

// function updateScore() {
//   // Check each section and decrease score accordingly
//   const allSections = [
//     { states: carpetStates, decrease: 5 },
//     { states: plasticPanelStates, decrease: 5 },
//     { states: seatStates, decrease: 5 },
//     { states: rubberComponentsStates, decrease: 5 },
//     { states: glassAndMirrorsStates, decrease: 5 },
//     { states: tyresStates, decrease: 5 },
//     { states: carsCoreMechanicalStates, decrease: 5 },
//     { states: fluidLevelStates, decrease: 5 }
//   ];

//   // Loop through each section and reduce the score
//   allSections.forEach(section => {
//     section.states.forEach((state, index) => {
//       console.log(`State ${index + 1}:`, state); // Log the value of each state

//       // Skip deduction for exempt fluid level states
//       if (
//         section === fluidLevelStates &&
//         exemptFluidLevelStates.includes(state)
//       ) {
//         console.log(`State ${index + 1} is exempt, no deduction.`);
//         return;
//       }

//       if (state) {
//         console.log(`State ${index + 1} has a value, deducting ${section.decrease}%`);
//         scorePercentage -= section.decrease;
//       }
//     });
//   });

//   // Ensure score stays between 96 and 99
//   if (scorePercentage < 96) {
//     scorePercentage = 96;
//   } else if (scorePercentage > 99) {
//     scorePercentage = 99;
//   } else {
//     // Randomize the score between 96 and 99 if it's within that range
//     scorePercentage = Math.random() * (99 - 96) + 96;
//   }
// }

// // Call the function to update the score based on reportData
// updateScore();

// Example Usage
const initialPercentage = 100;

// Condition to check if "Yes" should reduce 0.82%
const isOdometerConditionMet = reportData?.odometerBasic < reportData?.distKMS ? "Yes" : "No";

// Function to calculate final score percentage
function calculateScorePercentage() {
  // List of total deductions
  const totalDeductions = [
    // totalDeduction,
    totalDeductionEngine,
    totalDeductionSystemObservations,
    // totalDeductionCarpet,
    // totalDeductionPlasticPanel,
    // totalDeductionSeat,
    // totalDeductionRubberComponents,
    // totalDeductionGlassAndMirrors,
    totalDeductionTyres,
    totalDeductionCarsCoreMechanical,
    totalDeductionFluidLevel,
    // totalDeductionPanelGap,
    // totalDeductionInfotainmentAndEletronicFeatures
  ];

  // Start with the initial percentage
  let finalScore = initialPercentage;

  // Apply deductions from the array
  finalScore = totalDeductions.reduce((accumulatedPercentage, deduction) => {
    return accumulatedPercentage - deduction;
  }, finalScore);

  // If the condition is "Yes", reduce an additional 0.82%
  // if (isOdometerConditionMet === "Yes") {
  //   finalScore -= 0.82;
  // }

  // Return the final score
  return finalScore.toFixed(2);  // Format to 2 decimal places
}

// Calculate and store the final score percentage
const scorePercentage = calculateScorePercentage();

// console.log(`Final Score Percentage: ${scorePercentage}%`);

const calculatePercentage = (value) => {
  const maxValue = 9;
  if (value >= maxValue) {
    return '100%';
  }
  return `${((value / maxValue) * 100).toFixed(2)}%`; // Calculate percentage and round to two decimals
};

// const hasIssues = (reportData) => {
//   const conditions = [
//     reportData?.selectedConditionCarsCore2, reportData?.selectedConditionCarsCore3, reportData?.selectedConditionCarsCore1,
//     reportData?.selectedConditionCarsCore11, reportData?.selectedConditionCarsCore4, reportData?.selectedConditionCarsCore5,
//     reportData?.selectedConditionCarsCore6, reportData?.selectedConditionCarsCore7, reportData?.selectedConditionCarsCore8,
//     reportData?.selectedConditionCarsCore9, reportData?.selectedConditionCarsCore10, reportData?.selectedConditionCarsCore12,
//   ];
//   return conditions.some(condition => condition === "Issue Found");
// };

const socialIcons = [facebook, twitter, instagram, linkedin];

const currentYear = new Date().getFullYear();

  return (
  <Document>
    <Page style={styles.page}>
      {/* Navigation Part */}

      <View style={styles.main}>
        <Image style={styles.logo} src={logo} />
        <Text style={styles.header}>Pre Trip Inspection Report</Text>
      </View>

      {/* Navigation aprt End point */}

      {/* Name */}

      <View style={styles.container}>
        <View style={styles.loginContainer}>
          <Image style={styles.login} src={profile} />
          <Text style={styles.loginName}>{serviceData.customerName || "N/A"}</Text>
        </View>
      </View>

      {/* First Flex */}
      <View
        style={[
          styles.sectionmain,
          { justifyContent: "space-between", paddingHorizontal: 50 },
        ]}
      >
        {/* Left side */}
        <View style={[styles.leftContainer, { flex: 1, marginRight: 10 }]}>
          <View style={styles.headerLeft}>
          <Text style={styles.labelHeader}>
            {serviceData.vehicleMake && serviceData.vehicleModel 
              ? `${serviceData.vehicleMake} ${serviceData.vehicleModel}` 
              : "N/A"}
          </Text>
          </View>
          <View style={styles.headerLeft}>
            <Text style={styles.label}>{serviceData.variant || "N/A"}</Text>
          </View>
          <View style={styles.imageRow}>
            <Image style={styles.imageCar} src={carImageUrl || car} />
          </View>
          <View style={styles.containerGrays}>
            {/* Inner */}

            <View style={{ flexDirection: "row" }}>
              <View style={styles.carDetialsText}>
                <Text style={styles.carDetailsTextDetailsNum}>{serviceData.bhp || 'N/A'}</Text>
                <Text style={styles.carDetailsTextDetails}>BHPS</Text>
              </View>
              <View style={styles.carDetialsText}>
                <Text style={styles.carDetailsTextDetailsNum}>{serviceData.airbags || 'N/A'}</Text>
                <Text style={styles.carDetailsTextDetails}>Airbag</Text>
              </View>
              <View style={styles.carDetialsText}>
                <Text style={styles.carDetailsTextDetailsNum}>{serviceData.mileage || 'N/A'}</Text>
                <Text style={styles.carDetailsTextDetails}>Mileage (kmpl)</Text>
              </View>
              <View style={[styles.carDetialsText, { borderRightWidth: 0 }]}>
                <Text style={styles.carDetailsTextDetailsNum}>{serviceData.ncap || 'N/A'}</Text>
                <Text style={styles.carDetailsTextDetails}>NCAP</Text>
              </View>
            </View>
          </View>

          <View style={styles.containerGray2}>
            <Text>
              <Text style={{ fontWeight: "bold", fontSize: 12 }}>
                Booking ID &nbsp; : &nbsp;{" "}
              </Text>
              {/* Light font for static text */}
              <Text style={{ fontWeight: "100", fontSize: 10 }}>
                {serviceData._id || "N/A"}
              </Text>
              {/* Bold for dynamic text */}
            </Text>
            <Text style={{ fontWeight: "bold", fontSize: 12 }}>
              PDI Date &nbsp;: &nbsp;{" "}
              <Text style={{ fontWeight: "100", fontSize: "10px" }}>
              {reportData.pdiDate ? reportData.pdiDate : new Date().toLocaleDateString('en-US')}
              </Text>
            </Text>

            <Text style={{ fontWeight: "bold", fontSize: 12 }}>
              Conducted By &nbsp;:&nbsp;{" "}
              <Text style={{ fontWeight: "100", fontSize: "10px" }}>
                {reportData.technicianName || "N/A"}
              </Text>
            </Text>

            <Text style={{ fontWeight: "bold", fontSize: 12 }}>
              Time &nbsp;: &nbsp;{" "}
              <Text style={{ fontWeight: "100", fontSize: "10px" }}>
              {reportData.pdiTime ? reportData.pdiTime : new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
              </Text>
            </Text>

            <Text style={{ fontWeight: "bold", fontSize: 12 }}>
              Dealer &nbsp;: &nbsp;{" "}
              <Text style={{ fontWeight: "100", fontSize: "10px" }}>
                {reportData.selectedButton ? "Done" : "N/A"}
              </Text>
            </Text>

            <Text style={{ fontWeight: "bold", fontSize: 12 }}>
              VIN&nbsp;:&nbsp;{" "}
              <Text style={{ fontWeight: "100", fontSize: "10px" }}>
                {reportData.vinNumber || "N/A"}
              </Text>
            </Text>

            <Text style={{ fontWeight: "bold", fontSize: 12 }}>
              Transmission &nbsp;:&nbsp;{" "}
              <Text style={{ fontWeight: "100", fontSize: "10px" }}>
                {reportData.transmission || "N/A"}
              </Text>
            </Text>

            <Text style={{ fontWeight: "bold", fontSize: 12 }}>
              Fuel &nbsp;:&nbsp;{" "}
              <Text style={{ fontWeight: "100", fontSize: "10px" }}>
                {serviceData.fuel || "N/A"}
              </Text>
            </Text>

            <Text style={{ fontWeight: "bold", fontSize: 12 }}>
              Engine Number &nbsp;:&nbsp;{" "}
              <Text style={{ fontWeight: "100", fontSize: "10px" }}>
                {reportData.engineNumber || "N/A"}
              </Text>
            </Text>

            <Text style={{ fontWeight: "bold", fontSize: 12 }}>
              Engine Type &nbsp;:&nbsp;{" "}
              <Text style={{ fontWeight: "100", fontSize: "10px" }}>
                {serviceData.engine || "N/A"}
              </Text>
            </Text>

            <Text style={{ fontWeight: "bold", fontSize: 12 }}>
              Emission Type &nbsp;:&nbsp;{" "}
              <Text style={{ fontWeight: "100", fontSize: "10px" }}>
                {reportData.emissionType || "N/A"}
              </Text>
            </Text>

            <Text style={{ fontWeight: "bold", fontSize: 12 }}>
              Keys &nbsp;: &nbsp;{" "}
              <Text style={{ fontWeight: "100", fontSize: "10px" }}>
                {reportData.keysBasic || "N/A"}
              </Text>
            </Text>
          </View>
        </View>

        {/* Right side */}
        <View
          style={[
            styles.rightContainer,
            { flex: 1, alignItems: "center", justifyContent: "center" },
          ]}
        >
          {/* Top Container */}

          <View style={[styles.GrayContainerRight, { marginBottom:'20px' }]}>
          <Text style={[styles.cardHeading, { fontFamily: 'PoppinsS' }]}>
            Overall Reliability Assessment
          </Text>

            <View style={styles.progressBarContainer}>
              <View style={styles.progressBar(scorePercentage)} />
            </View>
            <Text style={styles.label}>{scorePercentage}%</Text>

            {/* Optional: Text Rating */}
            <View style={styles.GrayContainerRights}>
              <Text style={[styles.textHeading, { fontFamily: 'PoppinsS' }]}>
                Rating:{" "}
                {scorePercentage >= 75
                  ? "Excellent"
                  : scorePercentage >= 50
                  ? "Average"
                  : "Unsatisfactory"}
              </Text>
            </View>
            <Text style={styles.textHeading}>
            {scorePercentage >= 75
                  ? "This score signifies that this car is free of defects and meets the highest standards."
                  : scorePercentage >= 50
                  ? "This score indicates the car has moderate defects but is generally functional."
                  : "This score reflects significant defects, requiring immediate attention or repairs."}
            </Text>
          </View>

          {/* Bottom Container */}
          {/* <View style={styles.cardContainer}>

  <View style={styles.statusContainer}>
    <Text style={styles.statusText}>
      Status: <Text
      style={[
        styles.statusOkText,
        {
          color: reportData?.odometerBasic < reportData?.distKMS ? "#ED2024" : "#3ADB1A",
        },
      ]}
    >
      {reportData?.odometerBasic < reportData?.distKMS ? "Issue Found" : "ALL OK"}
    </Text>
    </Text>
  </View>

  <Text style={styles.cardHeading}>
    Car Driven Before PDI Date
  </Text>

  <Text style={styles.cardSubText}>
    Current ODO (Kms): {reportData?.odometerBasic ?? "N/A"}
  </Text>

  <Text style={[styles.cardSubText , { fontFamily: 'PoppinsS'}]}>
    ODO Tampering: {reportData?.odometerBasic <= reportData?.distKMS ? "No" : "Yes"}
  </Text>

  <Text style={styles.cardDescription}>
    The ODO Reading Of Your Car At The Time Of The PDI Was Recorded As {reportData?.odometerBasic ?? "N/A"} Kilometers,  The Vehicle's Actual Usage Is Also {reportData?.distKMS ?? "N/A"} Kilometers.
  </Text>
</View> */}

        </View>
      </View>

      {(reportData?.basicFile1 || reportData?.basicFile2 || reportData?.basicFile3 || reportData?.basicFile4) && (
      <View style={styles.imageFirst}>
        {/* First Row */}
        <View style={styles.imageRows}>
          {reportData?.basicFile1 && (
            <Image style={styles.imagePlaceholder} src={reportData?.basicFile1} />
          )}
          {reportData?.basicFile2 && (
            <Image style={styles.imagePlaceholder} src={reportData?.basicFile2} />
          )}
        </View>

        {/* Second Row */}
        <View style={styles.imageRows}>
          {reportData?.basicFile3 && (
            <Image style={styles.imagePlaceholder} src={reportData?.basicFile3} />
          )}
          {reportData?.basicFile4 && (
            <Image style={styles.imagePlaceholder} src={reportData?.basicFile4} />
          )}
        </View>
        </View>
        )}

      {/* Core */}

      <View  style={[
    styles.vehicleObservationsContainer,
    { 
      marginTop: '120px', 
      paddingVertical: '20px', // Adds vertical padding
      minHeight: '500px'      // Ensures a minimum height
    }
  ]}>
        <Text style={styles.EnginePerformanceHeadingText}>
          Core Mechanical System Check
        </Text>
        {/* Existing Content */}
        <View style={styles.observationsDetailsContainer}>
  {/* Heading */}
  
  {/* Status Badge */}
  <View style={styles.observationsStatusBadge}>
  <Text style={styles.statusBadgeTexts}>
            Status:{" "}
            {
              // Check if any issue is found in the Core Mechanical System Check
              reportData?.selectedConditionCarsCore2 ||
              reportData?.selectedConditionCarsCore3 ||
              reportData?.selectedConditionCarsCore1 ||
              reportData?.selectedConditionCarsCore11 ||
              reportData?.selectedConditionCarsCore4 ||
              reportData?.selectedConditionCarsCore5 ||
              reportData?.selectedConditionCarsCore6 ||
              reportData?.selectedConditionCarsCore7 ||
              reportData?.selectedConditionCarsCore8 ||
              reportData?.selectedConditionCarsCore9 ||
              reportData?.selectedConditionCarsCore10 ||
              reportData?.selectedConditionCarsCore12
                ? <Text style={{ color: "#ED2024" }}>Issue Found</Text>
                : <Text style={{ color: "#3ADB1A" }}>Perfect</Text>
            }
</Text>
</View>

  {/* Table Header */}
  <View style={[styles.tableHeaderRow ,  { fontFamily: 'PoppinsS' }]}>
    <Text style={[styles.tableHeaderCell, styles.column1]}>Area</Text>
    <Text style={[styles.tableHeaderCell, styles.column2]}>Status</Text>
    <Text style={[styles.tableHeaderCell, styles.column3]}>Issues</Text>
  </View>

  {/* Table Rows */}
  {[
    [
      "Engine Systems", 
      reportData?.selectedConditionCarsCore2 ? "Issue Found" : "All System OK",
      reportData?.selectedConditionCarsCore2 || "Nil"
    ],
    [
      "Brake Systems", 
      reportData?.selectedConditionCarsCore3 ? "Issue Found" : "All System OK", 
      reportData?.selectedConditionCarsCore3 ? "To Be Rectified By The Dealer" : "Nil"
    ],
    [
      "HVAC / AC Systems", 
      reportData?.selectedConditionCarsCore1 ? "Issue Found" : "All System OK", 
      reportData?.selectedConditionCarsCore1 || "Nil"
    ],
    [
      "Clutch & Transmission", 
      (!reportData?.selectedConditionCarsCore11) 
        ? "All Systems OK" 
        : (reportData?.selectedConditionCarsCore11 ? "Issue Found" : "All Systems OK"), 
      (!reportData?.selectedConditionCarsCore11) 
        ? "Nil" 
        : (reportData?.selectedConditionCarsCore11)
    ],
    [
      "Steering & Suspensions Systems", 
      reportData?.selectedConditionCarsCore4 ? "Issue Found" : "All System OK", 
      reportData?.selectedConditionCarsCore4 || "Nil"
    ],
    [
      "Fuel systems", 
      reportData?.selectedConditionCarsCore5 ? "Issue Found" : "All System OK", 
      reportData?.selectedConditionCarsCore5 || "Nil"
    ],
    [
      "Battery systems", 
      reportData?.selectedConditionCarsCore6 ? "Issue Found" : "All System OK", 
      reportData?.selectedConditionCarsCore6 || "Nil"
    ],
    [
      "Exhaust systems", 
      reportData?.selectedConditionCarsCore7 ? "Issue Found" : "All System OK", 
      reportData?.selectedConditionCarsCore7 || "Nil"
    ],
    [
      "Filters", 
      reportData?.selectedConditionCarsCore8 ? "Issue Found" : "All System OK", 
      reportData?.selectedConditionCarsCore8 || "Nil"
    ],
    [
      "Ignition systems", 
      reportData?.selectedConditionCarsCore9 ? "Issue Found" : "All System OK", 
      reportData?.selectedConditionCarsCore9 || "Nil"
    ],
    [
      "Lighting Systems", 
      reportData?.selectedConditionCarsCore10 ? "Issue Found" : "All System OK", 
      reportData?.selectedConditionCarsCore10 || "Nil"
    ],
    [
      "Sensors", 
      (!reportData?.selectedConditionCarsCore12) 
        ? "All Systems OK" 
        : (reportData?.selectedConditionCarsCore12 ? "Issue Found" : "All Systems OK"), 
      (!reportData?.selectedConditionCarsCore12) 
        ? "Nil" 
        : (reportData?.selectedConditionCarsCore12)
    ],
    ].map(([system, status, recommendation], index) => (
      <View key={index} style={styles.tableRows }>
        <Text style={[styles.tableCell, styles.column1]}>{system}</Text>
        <Text
          style={[
            styles.tableCell, 
            styles.column2, 
            { color: status === "Issue Found" ? "#ED2024" : "#000" }
          ]}
        >
          {status}
        </Text>
        <Text
          style={[
            styles.tableCell, 
            styles.column3, 
            { color: recommendation !== "Nil" ? "#ED2024" : "#000" }
          ]}
        >
          {recommendation}
        </Text>
      </View>
      ))}

    </View>
      </View>

      {/* Engine Performanve Duration */}

      <View style={[styles.EnginePerformanceHeading , { marginTop: '180px'}]}>
        <Text style={styles.EnginePerformanceHeadingText}>
          Engine Performance During Idle
        </Text>
      </View>

      <View style={[styles.evaluationContainer, { minHeight:'200px', marginBottom:'30px' }]}>
      {/* Status Badge */}
      <View style={styles.statusBadge}>
        <Text style={styles.statusBadgeText}>
          Status:{" "}
          {
            // Check if there's any red text (issue found)
            reportData?.BatteryEnergy < 11.5 || reportData?.LoadEngine > 35 || reportData?.idleRPM > 1400
              ? <Text style={{ color: "#ED2024" }}>Issue Found</Text>
              : <Text style={{ color: "#3ADB1A" }}>Perfect</Text>
          }
        </Text>
      </View>

      {/* Title */}
      <Text style={styles.EnginePerformanceHeadingText}>Real-Time Parameter Evaluation</Text>

      {/* Table Header */}
      <View style={[styles.tableRow, { flexDirection: 'row', alignItems: 'center', justifyContent: 'center'  , fontFamily:'PoppinsS'}]}>
  <Text style={[styles.tableHeader, styles.col1]}>System</Text>
  <Text style={[styles.tableHeader, styles.col2]}>Observation</Text>
  <Text style={[styles.tableHeader, styles.col3]}>Recommendation</Text>
</View>

      {/* Table Rows */}
      <View style={[styles.tableRow, { flexDirection: 'row', alignItems: 'center', justifyContent: 'center' , textAlign:'center' }]}>
        <Text style={[styles.evaluationLabel, styles.col1]}>
          Battery Voltage (v)
        </Text>
        <Text
          style={[
            styles.evaluationLabel,
            styles.col2,
            reportData?.BatteryEnergy < 11.5 ? { color: "#ED2024" } : { color: "#000" },
          ]}
        >
          {reportData?.BatteryEnergy < 11.5 ? reportData?.BatteryEnergy : reportData?.BatteryEnergy}
        </Text>
        <Text
          style={[
            styles.evaluationLabel,
            styles.col3,
            reportData?.BatteryEnergy < 11.5 ? { color: "#ED2024" } : { color: "#000" },
          ]}
        >
          {reportData?.BatteryEnergy < 11.5
            ? "To Be Rectified By The Dealer"
            : "Nil"}
        </Text>
      </View>
      <View style={[styles.tableRow, { flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }]}>
        <Text style={[styles.evaluationLabel, styles.col1]}>
          Engine Load (%)
        </Text>
        <Text
          style={[
            styles.evaluationLabel,
            styles.col2,
            reportData?.LoadEngine > 35 ? { color: "#ED2024" } : { color: "#000" },
          ]}
        >
          {reportData?.LoadEngine > 35 ? reportData?.LoadEngine : reportData?.LoadEngine}
        </Text>
        <Text
          style={[
            styles.evaluationLabel,
            styles.col3,
            reportData?.LoadEngine > 35 ? { color: "#ED2024" } : { color: "#000" },
          ]}
        >
          {reportData?.LoadEngine > 35
            ? "To Be Rectified By The Dealer"
            : "Nil"}
        </Text>
      </View>
      <View style={[styles.tableRow, { flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }]}>
        <Text style={[styles.evaluationLabel, styles.col1]}>
          Idle RPM
        </Text>
        <Text
          style={[
            styles.evaluationLabel,
            styles.col2,
            reportData?.idleRPM > 1400 ? { color: "#ED2024" } : { color: "#000" },
          ]}
        >
          {reportData?.idleRPM > 1400 ? reportData?.idleRPM : reportData?.idleRPM}
        </Text>
        <Text
          style={[
            styles.evaluationLabel,
            styles.col3,
            reportData?.idleRPM > 1400 ? { color: "#ED2024" } : { color: "#000" },
          ]}
        >
          {reportData?.idleRPM > 1400 ? "To Be Rectified By The Dealer" : "Nil"}
        </Text>
      </View>
    </View>

    <View  style={[
    styles.vehicleObservationsContainer,
    { minHeight: '400px' } // Add a minimum height
  ]}>
        {/* Existing Content */}
        <View style={styles.observationsDetailsContainer}>
        {/* Heading */}
        <Text style={styles.observationsHeading}>System Observations</Text>

        {/* Status Badge */}
        <View style={styles.observationsStatusBadge}>
          <Text style={styles.statusBadgeTexts}>
            Status:{" "}
            {
              // Check if any issue is found in the observations
              !reportData?.isToggledEngineCrack ||
              !reportData?.isToggledWarning ||
              !reportData?.isToggledSuspicious ||
              !reportData?.isToggledSmoke ||
              !reportData?.isToggledGearshift ||
              !reportData?.isToggledBreak ||
              !reportData?.isToggledSteering ||
              !reportData?.isToggledHandbreak ||
              !reportData?.isToggledReverse ||
              !reportData?.isToggledSmooth
                ? <Text style={{ color: "#ED2024" }}>Issue Found</Text>
                : <Text style={{ color: "#3ADB1A" }}>Perfect</Text>
            }
          </Text>
        </View>

        {/* Table Header */}
        <View style={[styles.tableHeaderRow ,  { fontFamily: 'PoppinsS' }]}>
          <Text style={[styles.tableHeaderCell, styles.column1]}>System</Text>
          <Text style={[styles.tableHeaderCell, styles.column2]}>Status</Text>
          <Text style={[styles.tableHeaderCell, styles.column3]}>Recommendation</Text>
        </View>

        {/* Table Rows */}
        {[
          [
            "Engine Crank", 
            !reportData?.isToggledEngineCrack ? "Issue Found" : "All System OK",
            !reportData?.isToggledEngineCrack ? "To Be Rectified By The Dealer" : "Nil"
          ],
          [
            "Instrument Cluster", 
            !reportData?.isToggledWarning ? "Issue Found" : "All System OK",
            !reportData?.isToggledWarning ? "To Be Rectified By The Dealer" : "Nil"
          ],
          [
            "Vibration, Noise, Smell", 
            !reportData?.isToggledSuspicious ? "Issue Found" : "All System OK",
            !reportData?.isToggledSuspicious ? "To Be Rectified By The Dealer" : "Nil"
          ],
          [
            "Excessive Smoke From Exhaust", 
            !reportData?.isToggledSmoke ? "Issue Found" : "All System OK",
            !reportData?.isToggledSmoke ? "To Be Rectified By The Dealer" : "Nil"
          ],
          [
            "Gear Shifting", 
            !reportData?.isToggledGearshift ? "Issue Found" : "All System OK",
            !reportData?.isToggledGearshift ? "To Be Rectified By The Dealer" : "Nil"
          ],
          [
            "Pedal Play", 
            !reportData?.isToggledBreak ? "Issue Found" : "All System OK",
            !reportData?.isToggledBreak ? "To Be Rectified By The Dealer" : "Nil"
          ],
          [
            "Steering Responsiveness", 
            !reportData?.isToggledSteering ? "Issue Found" : "All System OK",
            !reportData?.isToggledSteering ? "To Be Rectified By The Dealer" : "Nil"
          ],
          [
            "Parking Brake", 
            !reportData?.isToggledHandbreak ? "Issue Found" : "All System OK",
            !reportData?.isToggledHandbreak ? "To Be Rectified By The Dealer" : "Nil"
          ],
          [
            "Reverse Gear & Sensor", 
            !reportData?.isToggledReverse ? "Issue Found" : "All System OK",
            !reportData?.isToggledReverse ? "To Be Rectified By The Dealer" : "Nil"
          ],
          [
            "Speedometer & Tachometer", 
            !reportData?.isToggledSmooth ? "Issue Found" : "All System OK",
            !reportData?.isToggledSmooth ? "To Be Rectified By The Dealer" : "Nil"
          ],
        ].map(([system, status, recommendation], index) => (
          <View key={index} style={styles.tableRows   }>
            <Text style={[styles.tableCell, styles.column1]}>{system}</Text>
            <Text
              style={[
                styles.tableCell,
                styles.column2,
                status === "Issue Found" ? { color: "#ED2024" } : { color: "#000" },
              ]}
            >
              {status}
            </Text>
            <Text
              style={[
                styles.tableCell,
                styles.column3,
                recommendation === "To Be Rectified By The Dealer" ? { color: "#ED2024" } : { color: "#000" },
              ]}
            >
              {recommendation}
            </Text>
          </View>
        ))}
      </View>
      </View>

      {/* Fluid Inspection */}

      <View  style={[
    styles.vehicleObservationsContainer,
    { minHeight: '300px' } // Add a minimum height
  ]}>
        <Text style={styles.EnginePerformanceHeadingText}>
          Fluid Inspection
        </Text>
        {/* Existing Content */}
        <View style={styles.observationsDetailsContainer}>
          {/* Heading */}

          {/* Status Badge */}
          <View style={styles.observationsStatusBadge}>
          <Text style={styles.statusBadgeTexts}>
            Status:{" "}
            {
              // Check if any issue is found in the observations
              !reportData?.isToggledFluidLevel1 ||
              reportData?.isToggledFluidLevel2 ||
              !reportData?.isToggledFluidLevel3 ||
              reportData?.isToggledFluidLevel2 ||
              !reportData?.isToggledFluidLevel5 ||
              reportData?.isToggledFluidLevel6 ||
              !reportData?.isToggledFluidLevel7 ||
              reportData?.isToggledFluidLevel8 ||
              reportData?.isToggledFluidLevel9 ||
              reportData?.isToggledFluidLevel10 ||
              reportData?.isToggledFluidLevel11
                ? <Text style={{ color: "#ED2024" }}>Issue Found</Text>
                : <Text style={{ color: "#3ADB1A" }}>Perfect</Text>
            }
          </Text>
          </View>

          {/* Table Header */}
          <View style={[styles.tableHeaderRow ,  { fontFamily: 'PoppinsS' }]} >
            <Text style={[styles.tableHeaderCell, styles.column1]}>Area</Text>
            <Text style={[styles.tableHeaderCell, styles.column2]}>
              Condition
            </Text>
            <Text style={[styles.tableHeaderCell, styles.column2]}>
              Contamination
            </Text>
            <Text style={[styles.tableHeaderCell, styles.column3]}>
              Recommendation
            </Text>
          </View>

        {/* Table Rows */}
        {[
          [
            "Coolant", 
            !reportData?.isToggledFluidLevel1 ? "Not In Range" : "Within Range", 
            reportData?.isToggledFluidLevel2 ? "Issue Found" : "All System OK",  
            (reportData?.isToggledFluidLevel2 || !reportData?.isToggledFluidLevel1)
            ? "To Be Rectified By The Dealer" 
            : "Nil", 
          ],
          [
            "Engine Oil", 
            !reportData?.isToggledFluidLevel3 ? "Not In Range" : "Within Range", 
            reportData?.isToggledFluidLevel4 ? "Issue Found" : "All System OK",
            (reportData?.isToggledFluidLevel4 || !reportData?.isToggledFluidLevel3)
            ? "To Be Rectified By The Dealer" 
            : "Nil",
          ],
          [
            "Brake Oil", 
            !reportData?.isToggledFluidLevel5 ? "Not In Range" : "Within Range", 
            reportData?.isToggledFluidLevel6 ? "Issue Found" : "All System OK",
            (reportData?.isToggledFluidLevel6 || !reportData?.isToggledFluidLevel5)
            ? "To Be Rectified By The Dealer" 
            : "Nil",      
          ],
          [
            "Washer fluid", 
            !reportData?.isToggledFluidLevel7 ? "Not In Range" : "Within Range", 
            reportData?.isToggledFluidLevel8 ? "Issue Found" : "All System OK",
            (reportData?.isToggledFluidLevel8 || !reportData?.isToggledFluidLevel7)
            ? "To Be Rectified By The Dealer" 
            : "Nil",
          ],
          [
            "Auxiliary belts", 
            reportData?.isToggledFluidLevel9 ? "Issue Found" : "All System OK", 
            reportData?.isToggledFluidLevel9 ? "Nil" : "Nil", 
            reportData?.isToggledFluidLevel9 ? "To Be Rectified By The Dealer" : "Nil", 
          ],
          [
            "DEF/DPF", 
            reportData?.isToggledFluidLevel10 && reportData?.percentageValue < 50 
              ? "Below Range" 
              : "All System OK", 
            reportData?.isToggledFluidLevel10 && reportData?.percentageValue < 50 
              ? "Issue Found" 
              : "Nil", 
              reportData?.isToggledFluidLevel10 && reportData?.percentageValue < 50 
              ? "To Be Rectified By The Dealer" 
              : "Nil", 
          ],
          [
            "Leakages", 
            reportData?.isToggledFluidLevel11 ? "Issue Found" : "All System OK", 
            reportData?.isToggledFluidLevel11 ? "Nil" : "Nil",
            reportData?.isToggledFluidLevel11 ? "To Be Rectified By The Dealer" : "Nil",
          ]
        ].map(([area, condition, contamination, recommendation], index) => (
          <View key={index} style={styles.tableRows }>
            <Text style={[styles.tableCell, styles.column1]}>{area}</Text>
            <Text
              style={[
                styles.tableCell,
                styles.column2,
                condition === "Issue Found" || condition === "Not In Range" || condition === "Below Range" ? { color: "#ED2024" } : { color: "black" }
              ]}
            >
              {condition}
            </Text>
            <Text
              style={[
                styles.tableCell,
                styles.column3,
                (contamination === "Issue Found" || contamination === "To Be Rectified By The Dealer") 
                  ? { color: "#ED2024" } 
                  : { color: "black" }
              ]}
            >
              {contamination}
            </Text>
            <Text
              style={[
                styles.tableCell,
                styles.column3,
                recommendation === "To Be Rectified By The Dealer" ? { color: "#ED2024" } : { color: "black" }
              ]}
            >
              {recommendation}
            </Text>
          </View>
        ))}
        </View>
      </View>


      {/* Exterior Condition CheckInspection */}

      

      {/* Tyre Condition Overview */}

      <View  style={[
    styles.vehicleObservationsContainer,
    { minHeight: '250px', marginBottom:'120px' } // Add a minimum height
  ]}>
        {/* Existing Content */}
        <View style={styles.observationsDetailsContainer}>
          <Text style={styles.observationsHeading}>
            Tyre Condition Overview
          </Text>
          {/* Heading */}

          {/* Status Badge */}
          <View style={styles.observationsStatusBadge}>
          <Text style={styles.statusBadgeTexts}>
            Status:{" "}
            {
              // Check if any issue is found in the conditions
              reportData?.selectedConditionFT ||
              reportData?.selectedConditionRTN ||
              reportData?.selectedConditionRLN ||
              reportData?.selectedConditionFLNT ||
              reportData?.selectedConditionSparen
              ? (
                <Text style={{ color: "#ED2024" }}>Issue Found</Text>
              ) : (
                <Text style={{ color: "#3ADB1A" }}>Perfect</Text>
              )
            }
          </Text>
          </View>

          {/* Table Header */}
          <View style={[styles.tableHeaderRow ,  { fontFamily: 'PoppinsS' }]}>
            <Text style={[styles.tableHeaderCell, styles.column1]}>Tyre</Text>
            <Text style={[styles.tableHeaderCell, styles.column2]}>Brand</Text>
            <Text style={[styles.tableHeaderCell, styles.column3]}>
              Variant
            </Text>
            <Text style={[styles.tableHeaderCell, styles.column3]}>
              Size
            </Text>
            <Text style={[styles.tableHeaderCell, styles.column2]}>
              Condition
            </Text>
            <Text style={[styles.tableHeaderCell, styles.column3]}>
              Manufacturing
            </Text>
          </View>

          {/* Table Rows */}
          {[
          [
            "Front Right",
            reportData?.BrandT || "Nil",
            reportData?.BrandTv || "Nil",
            reportData?.selectedConditionSTS || "Nil",
            reportData?.selectedConditionFT || "All Ok",
            reportData?.selectedConditionDOTFT || "Nil", // Just display as is, no date formatting
          ],
          [
            "Rear Right",
            reportData?.BrandRT || "Nil",
            reportData?.VarientRT || "Nil",
            reportData?.selectedConditionRT || "Nil",
            reportData?.selectedConditionRTN || "All Ok",
            reportData?.selectedConditionDOTRT || "Nil", // Just display as is
          ],
          [
            "Rear Left",
            reportData?.BrandRL || "Nil",
            reportData?.VarientRL || "Nil",
            reportData?.selectedConditionRL || "Nil",
            reportData?.selectedConditionRLN || "All Ok",
            reportData?.selectedConditionDOTRL || "Nil", // Just display as is
          ],
          [
            "Front Left",
            reportData?.BrandFLN || "Nil",
            reportData?.VarientFLN || "Nil",
            reportData?.selectedConditionFLN || "Nil",
            reportData?.selectedConditionFLNT || "All Ok",
            reportData?.selectedConditionDOTFLN || "Nil", // Just display as is
          ],
          [
            "Spare",
            reportData?.BrandSpare || "Nil",
            reportData?.VarientSpare || "Nil",
            reportData?.selectedConditionSpare || "Nil",
            reportData?.selectedConditionSparen || "All Ok",
            reportData?.selectedConditionDOTSpare || "Nil", // Just display as is
          ],
          ].map(([Tyre, Brand, Variant, Size, Condition, Manufacturing], index) => (
            <View key={index} style={styles.tableRows}>
              <Text style={[styles.tableCell, styles.column1]}>{Tyre}</Text>
              <Text style={[styles.tableCell, styles.column3]}>{Brand}</Text>
              <Text style={[styles.tableCell, styles.column3]}>{Variant}</Text>
              <Text style={[styles.tableCell, styles.column3]}>{Size}</Text>
              <Text style={[styles.tableCell, styles.column3, { color: Condition === "All Ok" ? 'black' : '#ED2024' }]}>
                {Condition}
              </Text>
              <Text style={[styles.tableCell, styles.column3]}>{Manufacturing}</Text>
            </View>
          ))}
        </View>
      </View>

      {/* Images */}

      <View style={styles.imageThreeContainer}>
      {[
        "Front Right",
        "Rear Right",
        "Rear Left",
        "Front Left",
        "Spare",
      ].map((title, index) => {
        const fileKey = `tyreFile${index + 1}`; // Dynamically generate the property name
        const fileSrc = reportData?.[fileKey]; // Get the source URI for that property

        return (
          <View key={fileKey} style={styles.imageWithTitleContainer}>
            {/* Render Image only if fileSrc exists */}
            {fileSrc && <Image style={styles.boxImage} src={fileSrc} />}
            
            {/* Render Title only if fileSrc exists */}
            {fileSrc && <Text style={styles.imageTitle}>{title}</Text>}
          </View>
        );
        })}
      </View>

      <View
  style={[
    styles.vehicleObservationsContainer,
    { minHeight: '300px', justifyContent: 'center', alignItems: 'center' }, // Center-align content
  ]}
>
  {/* Heading */}
  <Text style={[styles.EnginePerformanceHeadingText,{marginBottom:'50px'}]}>
    Tire Life Evaluation
  </Text>

  <View style={styles.containerimage}>
    {/* Top Percentages */}
    <View style={styles.rowimage}>
      <View style={[styles.percentageBoximage, styles.topLeft]}>
        <Text style={styles.percentageTextimage}>
          {reportData?.BrandTRFR ? calculatePercentage(reportData.BrandTRFR) : '0%'}
        </Text>
      </View>

      <View style={[styles.percentageBoximage, styles.topRight]}>
        <Text style={styles.percentageTextimage}>
          {reportData?.TDRT ? calculatePercentage(reportData.TDRT) : '0%'}
        </Text>
      </View>
    </View>

    {/* Car Image */}
    <View style={styles.imageContainerimage}>
      <Image source={tyre} style={styles.tyreImage} resizeMode="contain" />
      {/* Spare Tire Percentage */}
      <View style={[styles.percentageBoximage, styles.spareTire]}>
        <Text style={styles.percentageTextimage}>
          {reportData?.Spare ? calculatePercentage(reportData.Spare) : '0%'}
        </Text>
      </View>
    </View>

    {/* Bottom Percentages */}
    <View style={styles.rowimage}>
      <View style={[styles.percentageBoximage, styles.bottomLeft]}>
        <Text style={styles.percentageTextimage}>
          {reportData?.FLN ? calculatePercentage(reportData.FLN) : '0%'}
        </Text>
      </View>

      <View style={[styles.percentageBoximage, styles.bottomRight]}>
        <Text style={styles.percentageTextimage}>
          {reportData?.RLTrend ? calculatePercentage(reportData.RLTrend) : '0%'}
        </Text>
      </View>
    </View>
  </View>
</View>



      {/* Interior Features Check
      <View style={styles.EnginePerformanceHeading}>
        <Text style={styles.EnginePerformanceHeadingText}>
          Interior Features Check
        </Text>
      </View> */}

     
     


       {/* Technician’s Remarks */}

       <View style={styles.vehicleObservationsContainer}>
      {/* Technician’s Remarks */}
      <View style={styles.observationsDetailsContainer}>
        {/* Heading */}
        <Text style={styles.observationsHeading}>Technician’s Remarks</Text>

        {/* List of Remarks */}
        <View style={styles.remarksList}>
          {reportData?.finalObservations?.split('\n').map((remark, index) => (
            <Text key={index} style={styles.remarkItem}>
              {`${index + 1}. ${remark.trim()}`}
            </Text>
          ))}
        </View>
      </View>
    </View>

    <View style={styles.footerContainer}>
      <View style={styles.contentWrapper}>
        {/* Logo and Description */}
        <View style={styles.sectionss}>
          <Image src={footerLogo} style={styles.footerLogo} />
          <Text style={styles.description}>
          Your trusted partner for expert vehicle inspections and road-ready confidence.
          </Text>
          <View style={styles.socialIcons}>
            {socialIcons.map((icon, index) => (
              <View key={index} style={styles.iconWrapper}>
                <Image src={icon} style={styles.socialIcon} />
              </View>
            ))}
          </View>
        </View>

        {/* Services Section */}
        <View style={styles.sectionss}>
          <Text style={styles.sectionHeading}>Our Services</Text>
          <Text style={styles.listItem}>Pre Delivery Inspection</Text>
          <Text style={styles.listItem}>Used Car Inspection</Text>
          <Text style={styles.listItem}>Pre-Trip Inspection</Text>
          <Text style={styles.listItem}>Driver Assistance</Text>
        </View>

        {/* Additional Services Section */}
        <View style={styles.sectionss}>
          <Text style={styles.sectionHeading}>Additional Services</Text>
          <Text style={styles.listItem}>Reviews</Text>
          <Text style={styles.listItem}>Careers</Text>
          <Text style={styles.listItem}>Pricing</Text>
          <Text style={styles.listItem}>Press Inquiries</Text>
        </View>

        {/* Contact Section */}
        <View style={styles.sectionss}>
          <Text style={styles.sectionHeading}>Contact Us</Text>
          <Text style={styles.listItem}>info@carvetpro.com</Text>
          <Text style={styles.listItem}>Bangalore, India 560100</Text>
        </View>
      </View>

      {/* Divider */}
      <View style={styles.dividers} />

      {/* Copyright */}
      <Text style={styles.copyright}>
        CARVETPRO © All rights reserved. Copyright {currentYear}
      </Text>
    </View>


      {/* <View style={styles.section}>
        <View style={styles.row}>
          <Text style={styles.label}>Customer Name:</Text>
          <Text style={styles.content}>{reportData.customerName || "N/A"}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Technician Name:</Text>
          <Text style={styles.content}>
            {reportData.technicianName || "N/A"}
          </Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Vehicle Model:</Text>
          <Text style={styles.content}>{reportData.vehicleModel || "N/A"}</Text>
        </View> */}
        {/* Add more sections as needed */}
      {/* </View> */}

      {/* <View style={styles.divider} />

      <Text style={[styles.label, { textAlign: "center", marginVertical: 10 }]}>
        Inspection Images
      </Text>
      <View style={styles.imageRows}>
        <Image style={styles.image} src={car} />
        <Image style={styles.image} src={qr} />
        <Image style={styles.image} src={cam} />
      </View> */}
    </Page>
  </Document>
);
};

export default PreTripPDF;
